import { UtensilsCrossed } from 'lucide-react';
import SidebarItem, { NavCountBadgeUrgent } from './sidebar/SidebarItem';

const ReservationsTablesNavItem = ({ pendingCount, onClick, isActive }) => {
  const hasPending = pendingCount > 0;

  return (
    <SidebarItem
      icon={UtensilsCrossed}
      label="Réservations tables"
      active={isActive}
      onClick={onClick}
      title={
        hasPending
          ? `${pendingCount} réservation(s) à valider`
          : 'Aucune réservation en attente de validation'
      }
      badge={hasPending ? <NavCountBadgeUrgent count={pendingCount} /> : null}
    />
  );
};

export default ReservationsTablesNavItem;
